import React from "react";
import { Routes, Route, BrowserRouter, Navigate } from "react-router-dom";
import { useAuth } from "@memberstack/react";
import Login from "./pages/auth/login";
import SignUp from "./pages/auth/signup";
import Resetpassword from "./pages/resetPassword";
import Auth from "./pages/auth";
import Edition from "./pages/edition";
import ChangePlan from "./pages/changePlan";
import Account from "./pages/account";
import ChangePassword from "./pages/changepassword";
import Archive from "./pages/archive";
import Gated from "./pages/gated";
import GatedView from "./pages/viewgated";
import PasswordProtection from "./pages/PasswordProtection";
import { ProtectedRoute } from "./components/ProtectedRoute";
import Footer from "./pages/footer";

export default function Router() {
  const { isLoggedIn } = useAuth();
  const isStaging = window.location.hostname === "stagingproxy.yews.news";

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/protect" element={<PasswordProtection />} />
        
        {/* Auth routes that are always protected */}
        <Route
          path="/auth"
          element={
            <ProtectedRoute>
              <Auth />
            </ProtectedRoute>
          }
        />
        <Route
          path="/account/login"
          element={
            <ProtectedRoute>
              <Login />
            </ProtectedRoute>
          }
        />
        <Route
          path="/account/signup"
          element={
            <ProtectedRoute>
              <SignUp />
            </ProtectedRoute>
          }
        />
        <Route
          path="/resetpassword"
          element={
            <ProtectedRoute>
              <Resetpassword />
            </ProtectedRoute>
          }
        />

        {/* Regular routes with conditional protection based on staging */}
        <Route
          path="*"
          element={
            isStaging ? (
              <ProtectedRoute>
                <Routes>
                <Route path="/home" element={<Edition />} />
                <Route path="/" index element={<Navigate to={'/home'} />} />
                  <Route path="/edition/:timestamp" element={<Edition />} />
                  <Route path="/footer" element={<Footer />} />
                  {isLoggedIn ? (
                    <React.Fragment>
                      <Route path="/archive" element={<Archive />} />
                      <Route path="/account/change-plan" element={<ChangePlan />} />
                      <Route path="/gated" element={<Gated />} />
                      <Route path="/viewgated/:gatedID" element={<GatedView />} />
                      <Route path="/changepassword" element={<ChangePassword />} />
                      <Route path="/account/dashboard" element={<Account />} />
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <Route path="*" element={<Navigate to={'/'} />} />
                    </React.Fragment>
                  )}
                </Routes>
              </ProtectedRoute>
            ) : (
              <Routes>
                <Route path="/home" element={<Edition />} />
                <Route path="/" index element={<Navigate to={'/home'} />} />
                <Route path="/edition/:timestamp" element={<Edition />} />
                <Route path="/footer" element={<Footer />} />
                {isLoggedIn ? (
                  <React.Fragment>
                    <Route path="/footer" element={<Footer />} />
                    <Route path="/archive" element={<Archive />} />
                    <Route path="/account/change-plan" element={<ChangePlan />} />
                    <Route path="/gated" element={<Gated />} />
                    <Route path="/viewgated/:gatedID" element={<GatedView />} />
                    <Route path="/changepassword" element={<ChangePassword />} />
                    <Route path="/account/dashboard" element={<Account />} />
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <Route path="*" element={<Navigate to={'/home'} />} />
                  </React.Fragment>
                )}
              </Routes>
            )
          }
        />
      </Routes>
    </BrowserRouter>
  );
}
